import BrButton from '@govbr/react-components/lib/BrButton';
import { useHistory } from 'react-router-dom';
import _ from 'underscore';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import auth from '../../../auth/Auth';
import AjudaRapida from '../../../components/AjudaRapida/AjudaRapida';
import Card from '../../../components/Card/Card';
import {
  limpar,
  selectCodigoErro,
  selectFamilia,
  selectMensagemErro,
  setIniciarExclusao,
} from '../exclusaoCadastralSlice';
import styles from './InicioExclusaoCadastral.module.css';
import imgErro from '../../../assets/img/icone-erro.png';
import imgSucesso from '../../../assets/img/icone-sucesso.png';
import imgAlerta from '../../../assets/img/icone-alerta.png';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Message from '../../../components/Message/Message';
import * as codigoMensagens from '../codigosMensagens';
import { selectPermiteRemoverPreFamiliaCadUnico, selectSituacaoCadastroFamilia } from '../../Perfil/perfilSlice';

const InicioExclusaoCadastral: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const familia = useAppSelector(selectFamilia);
  const codigoErro = useAppSelector(selectCodigoErro);
  const mensagemErro = useAppSelector(selectMensagemErro);
  const permiteRemoverPreFamiliaCadUnico = useAppSelector(selectPermiteRemoverPreFamiliaCadUnico);

  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);

  const obterIntegranteLogado = (cpf: string) => {
    return _.filter(familia?.integranteFamiliaDTOs, (integrante) => {
      return integrante.pessoaDadosCadastroDTO.numeroCpfPessoa === parseInt(cpf);
    });
  };

  let integranteLogado = obterIntegranteLogado(auth.getUser());

  const iniciarExclusao = async () => {
    dispatch(setIniciarExclusao(true));
  };

  const goToHome = async () => {
    await dispatch(limpar());
    history.push('/home');
  };

  const renderMessageSucesso = () => {
    return codigoErro && codigoMensagens.codigosSucesso.includes(codigoErro);
  };

  const renderMessageAlerta = () => {
    return codigoErro && codigoMensagens.codigosAlerta.includes(codigoErro);
  };

  const renderMessageErro = () => {
    return codigoErro && codigoMensagens.codigosErro.includes(codigoErro);
  };

  const splashExclusaoCadastro = async () => {
    await dispatch(limpar());
    history.push('/home');
    history.push('/como-excluir');
  };

  const obterNome = (integranteLogado) => {
    if (integranteLogado[0]?.pessoaDadosCadastroDTO?.temIdentidadeGenero == 1 && integranteLogado[0]?.pessoaDadosCadastroDTO?.nomeSocialApelidoPessoa?.length >= 1) {
      return integranteLogado[0]?.pessoaDadosCadastroDTO?.nomeSocialApelidoPessoa;
    }

    if (!integranteLogado[0]?.pessoaDadosCadastroDTO?.temIdentidadeGenero || integranteLogado[0]?.pessoaDadosCadastroDTO?.nomeSocialApelidoPessoa?.length <= 1) {
      if (integranteLogado[0]?.pessoaDadosCadastroDTO?.nomePessoa) {
        return integranteLogado[0]?.pessoaDadosCadastroDTO?.nomePessoa
      }
    }

    return situacaoCadastroFamilia?.nomeCnis;
  }

  const renderTelaPrincipal = () => {
      return (
        !codigoErro && familia && (
          <>
            <Card>
              {!integranteLogado[0]?.pessoaDadosCadastroDTO?.nomePessoa && <Skeleton count={15} />}

              {integranteLogado[0]?.pessoaDadosCadastroDTO?.nomePessoa && (
                <>
                  <div className={styles.tituloInicio}>Vamos iniciar?</div>
                  <div>
                    <div className={styles.userInfo}>
                      <i className={`fas fa-id-card-alt ${styles.icon}`} />
                      <span>
                        <strong>{obterNome(integranteLogado)}</strong>,
                        aqui você poderá solicitar o cancelamento do seu cadastro.
                      </span>
                    </div>
                    {!permiteRemoverPreFamiliaCadUnico && (
                      <div className={styles.userInfo}>
                        <span>
                          A funcionalidade CANCELE O SEU CADASTRO fica disponível das {' '}
                          <strong>7h às 19h.</strong>
                          <br />
                          <br /> Se não conseguir concluir hoje, tente novamente amanhã entre 7h e 19h.
                        </span>
                      </div>
                    )}
                  </div>
                  <hr />
                  <div className={styles.buttonArea}>
                    {!permiteRemoverPreFamiliaCadUnico && (
                      <BrButton
                        className={`${styles.button} ${styles.secondary}`}
                        onClick={() => goToHome()}
                      >
                        Voltar para o menu
                      </BrButton>
                    )}
                    <BrButton className={styles.button} onClick={() => iniciarExclusao()}>
                      {!permiteRemoverPreFamiliaCadUnico && (
                       <span>Cancele o seu cadastro</span>
                      )}
                      {permiteRemoverPreFamiliaCadUnico && (
                       <span>Cancele a sua solicitação de cadastramento</span>
                      )}
                    </BrButton>
                  </div>
                </>
              )}
            </Card>
            <AjudaRapida>
              Revise os integrantes da sua família com atenção.
              <p />
              Após conferir as informações, clique na declaração, se responsabilizando pelo
              cancelamento do seu cadastro.
              <p />
            </AjudaRapida>
          </>
        )
      );
  };

  return (
    <>
      <div className={styles.container}>
        {renderTelaPrincipal()}

        {renderMessageSucesso() && (
          <Card className={styles.card}>
            <div className={styles.containerMensagem}>
              <img className={styles.imgMessage} src={imgSucesso} alt="Imagem" />

              <Message
                type={'success'}
                text={
                  <>
                    <div>
                      <span>{mensagemErro}</span>
                    </div>
                  </>
                }
              />
              <p />
              <p />
              <div className={styles.botaoContainer}>
                <BrButton onClick={() => goToHome()} className={styles.botao}>
                  OK
                </BrButton>
              </div>
            </div>
          </Card>
        )}

        {renderMessageAlerta() && (
          <Card className={styles.card}>
            <div className={styles.containerMensagem}>
              <img className={styles.imgMessage} src={imgAlerta} alt="Imagem" />

              <Message
                type={'warning'}
                text={
                  <>
                    <div>
                      <span>{mensagemErro}</span>
                    </div>
                  </>
                }
              />
              <p />
              <p />
              <div className={styles.botaoContainer}>
                <BrButton onClick={() => goToHome()} className={styles.botao}>
                  OK
                </BrButton>
              </div>
            </div>
          </Card>
        )}

        {renderMessageErro() && (
          <Card className={styles.card}>
            <div className={styles.containerMensagem}>
              <img className={styles.imgMessage} src={imgErro} alt="Imagem" />

              <Message
                type={'error'}
                text={
                  <>
                    <div>
                      <span>{mensagemErro}</span>
                    </div>
                  </>
                }
              />
              {codigoErro !== "10" &&
                <div className={styles.messageText} onClick={() => splashExclusaoCadastro()}>
                  <br />
                  <span>
                    <strong>Saiba como cancelar o seu cadastro</strong>
                  </span>
                </div>
              }
              <p />
              <p />
              <div className={styles.botaoContainer}>
                <BrButton onClick={() => goToHome()} className={styles.botao}>
                  OK
                </BrButton>
              </div>
            </div>
          </Card>
        )}
      </div>
    </>
  );
};

export default InicioExclusaoCadastral;
